import { render, staticRenderFns } from "./EditTemplateMethod.vue?vue&type=template&id=6d5c8b5b&"
import script from "./EditTemplateMethod.vue?vue&type=script&lang=js&"
export * from "./EditTemplateMethod.vue?vue&type=script&lang=js&"
import style0 from "./EditTemplateMethod.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports